var map = {
	"./air-conditioner.svg": 1555,
	"./airplane.svg": 1556,
	"./airport.svg": 1557,
	"./approved.svg": 1558,
	"./aquapark.svg": 1559,
	"./arrow-answer-bubble.svg": 1560,
	"./arrow-back.svg": 1561,
	"./arrow-flight.svg": 1562,
	"./arrow-right-top.svg": 1563,
	"./arrow-right.svg": 1564,
	"./bar.svg": 1565,
	"./beach-surface-pebble.svg": 1566,
	"./beach-surface-platform.svg": 1567,
	"./beach-surface-sand-pebble.svg": 1568,
	"./beach-surface-sand.svg": 1569,
	"./beachsurface.svg": 1570,
	"./card.svg": 1571,
	"./check.svg": 1572,
	"./clock.svg": 1573,
	"./cvv.svg": 1574,
	"./double-arrow.svg": 1575,
	"./empty-hotel-map.svg": 1576,
	"./filters/clear-filters.svg": 1577,
	"./filters/filter-button.svg": 1578,
	"./filters/instant-confirm-colored.svg": 1579,
	"./filters/instant-confirm.svg": 1580,
	"./filters/search-distance.svg": 1581,
	"./filters/search-lift.svg": 1582,
	"./fire.svg": 1583,
	"./flight-direct-mobile.svg": 1584,
	"./flight-direct.svg": 1585,
	"./flight-direct__additional-mobile.svg": 1586,
	"./flight-direct__additional.svg": 1587,
	"./flight-transition-mobile.svg": 1588,
	"./flight-transition.svg": 1589,
	"./flight-transition__additional-mobile.svg": 1590,
	"./flight-transition__additional.svg": 1591,
	"./food.svg": 1592,
	"./free-cancellation-colored.svg": 1593,
	"./fuel-green.svg": 1594,
	"./fuel-white.svg": 1595,
	"./funicular.svg": 1596,
	"./gallery-empty.svg": 1597,
	"./garranty.svg": 1598,
	"./gender-female.svg": 1599,
	"./gender-male.svg": 1600,
	"./gender-unidentified.svg": 1601,
	"./gift.svg": 1602,
	"./glass.svg": 1603,
	"./gym.svg": 1604,
	"./hand-luggage.svg": 1605,
	"./heated-pool.svg": 1606,
	"./hold-luggage.svg": 1607,
	"./hotel-reply.svg": 1608,
	"./included-services.svg": 1609,
	"./included.svg": 1610,
	"./kids-club.svg": 1611,
	"./kids-menu.svg": 1612,
	"./kids-pool.svg": 1613,
	"./lightning.svg": 1614,
	"./lock.svg": 1615,
	"./logo.svg": 1616,
	"./lt-extra/bonus_insurance.svg": 1617,
	"./lt-extra/bonus_ivi.svg": 1618,
	"./luggage-wrapping.svg": 1619,
	"./man.svg": 1620,
	"./map-button.svg": 1621,
	"./map/collapse-arrows.svg": 1622,
	"./map/expand-arrows.svg": 1623,
	"./massage.svg": 1624,
	"./nanny.svg": 1625,
	"./only-lt-half.svg": 1626,
	"./parking.svg": 1627,
	"./payment-mir.svg": 1628,
	"./paymenttype.svg": 1629,
	"./plane-arrival.svg": 1630,
	"./plane.svg": 1631,
	"./private-beach.svg": 1632,
	"./rest_types/active.svg": 1633,
	"./rest_types/couples.svg": 1634,
	"./rest_types/family.svg": 1635,
	"./review-tab-selected.svg": 1636,
	"./sauna.svg": 1637,
	"./search-sorting.svg": 1638,
	"./searcher-empty-request.svg": 1639,
	"./searcher-filtered-empty.svg": 1640,
	"./sidebar-bottom-triangle.svg": 1641,
	"./sidebar-menu-active.svg": 1642,
	"./sign_additional.svg": 1643,
	"./ski-in-ski-out.svg": 1644,
	"./social-fb.svg": 1645,
	"./social-share.svg": 1646,
	"./social-vk.svg": 1647,
	"./special.svg": 1648,
	"./success_additional.svg": 1649,
	"./swimming-pool.svg": 1650,
	"./thumbs-up.svg": 1651,
	"./wave.svg": 1652,
	"./wifi.svg": 1653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;